import {useMutation, useQueryClient} from '@tanstack/react-query'
import addEmployee from './api/addEmployee'
import {useUser} from 'features/authorized/context/user'
import {EmployeeFormData} from '../../core/entities/employee'

const useAddEmployee = (onSuccess: () => void) => {
    const qc = useQueryClient()
    const {user} = useUser()

    const onMutationSuccess = () => {
        onSuccess()
        qc.invalidateQueries(['employees', 'get'])
    }
    return useMutation(
        ['employees', 'add'],
        (employee: EmployeeFormData) =>
            addEmployee({
                organizationId: user.organization.organizationId,
                employee,
            }),
        {onSuccess: onMutationSuccess},
    )
}

export default useAddEmployee
